/* @flow */
import { Container } from 'flux/utils';
import React from 'react';
import CurrentUser from 'auth/CurrentUser';
import Leads from 'collections/Leads';
import LeadStore from 'stores/LeadStore';
import mountTymkPrompt from 'utils/mountTymkPrompt';

type State = {
  leads: Leads,
};

class TymkRegistrationModals extends React.Component {
  state: State;

  static getStores() {
    return [LeadStore];
  }

  static calculateState(): State {
    return {
      leads: LeadStore.getLeads(),
    };
  }

  componentDidMount() {
    this.checkForPrompts();
  }

  componentDidUpdate() {
    this.checkForPrompts();
  }

  checkForPrompts() {
    const { leads } = this.state;

    if (leads.length > 0 && CurrentUser.didSetupAndJoinClassThisSession()) {
      mountTymkPrompt(this, 'onboarding', true);
    }
  }

  render() {
    return null;
  }
}

export default Container.create(TymkRegistrationModals, { pure: false });



// WEBPACK FOOTER //
// ./src/user/components/TymkRegistrationModals.jsx